module.exports = __webpack_public_path__ + "static/white-key-d9c4c154685ef2d7c4c1f888eb5bff21.png";